module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("ABOUT THE INTERURBAN RAILWAYS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many of the stories in this book are related to the Texas Electric Railway, an interurban system that served North Texas from 1908 through 1948. ("), _c('i', [_vm._v("Interurban")]), _vm._v(" means “traveling between cities”; an interurban system was an electric street railway with more than half of its rail lines outside of city limits.) The Texas Electric Railway spanned 266 miles, making it the largest interurban railway system west of the Mississippi River.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Texas Electric Railway was the result of the consolidation of the Denison and Sherman Railway, the Texas Traction Company, the Southern Traction Company and the Dallas Traction Company.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a main hub in Dallas, the Texas Electric Railway stretched south to Waco, north to Denison, west to Fort Worth, southeast to Corsicana, east to Terrell, southwest to Cleburne and northwest to Denton. The Texas system was one of hundreds of interurban systems across the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Interurban systems began springing up in the United States in the late nineteenth century. According to "), _c('i', [_vm._v("American Heritage")]), _vm._v(" magazine:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("A United States congressman, Charles L. Henry of Indiana, coined the word")]), _vm._v(" interurban "), _c('i', [_vm._v("to describe the two-mile electric line he opened in the spring of 1892 between Anderson and North Anderson, Indiana, but the fifteen-mile East Side Railway, which began operation between Portland and Oregon City, Oregon, in February of 1893, is usually regarded as the first true interurban. Others soon appeared in almost every part of the United States, and by the turn of the century, the boom was on.")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN1",
      "id": "FT1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P6-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Map of the Texas Electric Railway System that ran from 1908 to 1948. "), _c('i', [_vm._v("Courtesy of the Plano Conservancy for Historic Preservation.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, by the 1950s, most all of the interurbans were defunct, due to “R&R” (Rubber and Roads). Americans wanted automobiles and the freedom of the open road. They had little desire for the confines of mass transit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other stories contained in this volume come from across the state and include passenger trains, freight trains and trolleys, along with the interurbans. I hope you enjoy these stories of murder and mayhem on the Texas rails.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-463a704b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About_Interurban_Railways.vue
// module id = 66
// module chunks = 0